import React from 'react';
import { Routes, Route } from 'react-router-dom';
import styled from 'styled-components';
import AgentDashboard from './showingbooker/components/AgentDashboard';

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  background: #f8f9fa;
  min-height: 100vh;
`;


const ShowingBooker = () => {
  return (
    <Container>
      <Routes>
        <Route path="/" element={<AgentDashboard />} />
        {/* BookingPage is now served as a public route from App.js */}
      </Routes>
    </Container>
  );
};

export default ShowingBooker;